import { atom } from 'recoil';
import {
  MODAL_TRIGGER,
  PRIVACY_MODAL,
  PL_COMMIT,
  QUARTERLY_OP_DETAILS,
  QUARTER_INFO,
  GCSP_QUARTER_INFO,
  MSL_QUARTER_INFO,
  YEAR_WISE_DATA,
  PL_OPPS_DETAILS_MODAL,
  GCSP_OPPS_DETAILS_MODAL,
  PL_COMMENT_MODAL,
  GCSP_COMMENT_MODAL,
  PL_OPPS_NAME_DETAILS_WARNING_MODAL,
  GCSP_OPPS_DETAILS_WARNING_MODAL,
  PL_COMMENT_WARNING_MODAL,
  GCSP_COMMENT_WARNING_MODAL,
  PL_SUBMIT_SUCCESS_MODAL,
  PL_FAILURE_CONFIRMATION_MODAL,
  RECOIL_SELECTED_ACCOUNT_STATE,
  GCSP_OPP_VIEW,
  MSL_OPP_VIEW,
  CURRENT_USER,
  ACCOUNT_LIST,
  RECOIL_ALL_ACCOUNTS_QUARTER_STATE,
  GCSP_PAST_OPP_VIEW,
  PURSUIT_LEADER_TABLE_ROW_DATA,
  DASHBOARD_PROFILE_DETAILS,
  SUMMARY_DRAWER_TOGGLE,
  SYSTEM_DATE_TIME,
  NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE,
  ALL_MONTH_DATA,
  ALL_MONTH_MSL_DATA,
  NEXT_BUTTON_ACTIVE,
  OPERATING_SYSTEM,
  REFRESH_PL_SIDEBAR_DATA,
  TRIGGER_UPDATE_PL_SIDEBAR_DATA,
  PL_SIDEBAR_UPDATE_OPP_PAYLOAD,
  SIDEBAR_EXPAND_COLLAPSE_STATE,
  LOADING_MODAL_STATE,
  IS_BADDATA_AVAILABLE,
  REFRESH_PL_FORECAST_PAGE,
  CURRENT_PAGE_NAME,
  FULL_PAGE_LOADING_STATE,
  IS_READ_ONLY_STATE,
  SHOW_REFRESH_BUTTON_STATE,
  COUNTRY_NAME_STATE,
  IS_USER_AVAILABLE_STATE,
  FLATTENED_ACCOUNT_LIST_STATE,
  REFRESH_PILLS_STATUS_STATE,
  REFRESH_ALERT_BAR_STATE,
  IS_OPPS_BAD_DATA_AVAILABLE_STATE,
  MSL_OPPORTUNITY_STATE,
  REFRESH_AUTH_TOKEN,
  MSL_QUARTER_STATE_INFO,
  SUBMISSION_FAILURE,
  OPEN_SUPER_USER_MODAL_STATE,
  MESSAGE_MODAL_STATE,
  IS_MSL_DELEGATE,
} from '@recoil/recoilKeys';

export const PL_Commit_State = atom({
  key: PL_COMMIT,
  default: {},
});

export const Recoil_Quarter_State = atom({
  key: QUARTER_INFO,
  default: null,
});

export const Year_Wise_Data_State = atom({
  key: YEAR_WISE_DATA,
  default: {},
});

export const Quaterly_OP_Details_State = atom({
  key: QUARTERLY_OP_DETAILS,
  default: [],
});

export const Modal_Trigger_State = atom({
  key: MODAL_TRIGGER,
  default: false,
});

export const Privacy_Modal_State = atom({
  key: PRIVACY_MODAL,
  default: true,
});

export const Pl_Opps_Details_Modal_State = atom({
  key: PL_OPPS_DETAILS_MODAL,
  default: false,
});

export const Gcsp_Opps_Details_Modal_State = atom({
  key: GCSP_OPPS_DETAILS_MODAL,
  default: false,
});

export const Pl_Comment_Modal_State = atom({
  key: PL_COMMENT_MODAL,
  default: false,
});

export const Gcsp_Comment_Modal_State = atom({
  key: GCSP_COMMENT_MODAL,
  default: false,
});

export const Pl_Submit_Success_Modal_State = atom({
  key: PL_SUBMIT_SUCCESS_MODAL,
  default: false,
});

export const Pl_Failure_Modal_State = atom({
  key: PL_FAILURE_CONFIRMATION_MODAL,
  default: false,
});

export const Pl_Opps_Name_Details_Warning_Modal_State = atom({
  key: PL_OPPS_NAME_DETAILS_WARNING_MODAL,
  default: false,
});

export const Gcsp_Opps_Details_Warning_Modal_State = atom({
  key: GCSP_OPPS_DETAILS_WARNING_MODAL,
  default: false,
});

export const Pl_Comment_Warning_Modal_State = atom({
  key: PL_COMMENT_WARNING_MODAL,
  default: false,
});

export const Gcsp_Comment_Warning_Modal_State = atom({
  key: GCSP_COMMENT_WARNING_MODAL,
  default: false,
});

export const Gcsp_Opp_View_State = atom({
  key: GCSP_OPP_VIEW,
  default: [],
});
export const Msl_Opp_View_State = atom({
  key: MSL_OPP_VIEW,
  default: [],
});

export const Recoil_Gcsp_Quarter_State = atom({
  key: GCSP_QUARTER_INFO,
  default: null,
});
//new import for MSL
export const Recoil_Msl_Quarter_State = atom({
  key: MSL_QUARTER_INFO,
  default: null,
});

export const Recoil_Selected_Account_State = atom({
  key: RECOIL_SELECTED_ACCOUNT_STATE,
  default: null,
});

export const Current_User = atom({
  key: CURRENT_USER,
  default: null,
});

export const Gcsp_Active_Tab_State = atom({
  key: 'GCSP_ACTIVE_TAB_STATE',
  default: 'quarter',
});

export const Active_Tab_Gcsp = atom({
  key: 'ACTIVE_TAB_GCSP',
  default: '0',
});

//new import in recoil for MSL
export const Active_Tab_Msl = atom({
  key: 'ACTIVE_TAB_MSL',
  default: 0,
});
export const Account_List = atom({
  key: ACCOUNT_LIST,
  default: null,
});

export const Recoil_All_Accounts_Quarter_State = atom({
  key: RECOIL_ALL_ACCOUNTS_QUARTER_STATE,
  default: null,
});

export const Gcsp_Past_Opp_View_State = atom({
  key: GCSP_PAST_OPP_VIEW,
  default: [],
});

export const Dashboard_Profile_Details_State = atom({
  key: DASHBOARD_PROFILE_DETAILS,
  default: [],
});

export const PursuitLeaderTableRowDataState = atom({
  key: PURSUIT_LEADER_TABLE_ROW_DATA,
  default: [],
});

export const Recoil_Summary_Drawer_Toggle = atom({
  key: SUMMARY_DRAWER_TOGGLE,
  default: null,
});

export const System_Date_Time_State = atom({
  key: SYSTEM_DATE_TIME,
  default: null,
});

export const Now_Next_Beyond_Sidebar_Data_State = atom({
  key: NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE,
  default: null,
});

export const All_Month_MSL_Data_State = atom({
  key: ALL_MONTH_MSL_DATA,
  default: [
    {
      your_judge: null,
      your_total_commit: null,
    },
    {
      your_judge: null,
      your_total_commit: null,
    },
    {
      your_judge: null,
      your_total_commit: null,
    },
  ],
});

export const All_Month_Data_State = atom({
  key: ALL_MONTH_DATA,
  default: [
    {
      Missed: null,
      Committed: null,
      Not_Committed: null,
      Total_Forecasted: null,
      Your_Judge: null,
      Total_Commit: null,
    },
    {
      Missed: null,
      Committed: null,
      Not_Committed: null,
      Total_Forecasted: null,
      Your_Judge: null,
      Total_Commit: null,
    },
    {
      Missed: null,
      Committed: null,
      Not_Committed: null,
      Total_Forecasted: null,
      Your_Judge: null,
      Total_Commit: null,
    },
  ],
});

export const Next_Button_Active_State = atom({
  key: NEXT_BUTTON_ACTIVE,
  default: false,
});

export const Operating_System_State = atom({
  key: OPERATING_SYSTEM,
  default: null,
});

export const Refresh_Pl_Sidebar_Data = atom({
  key: REFRESH_PL_SIDEBAR_DATA,
  default: false,
});

export const Trigger_Update_Pl_Sidebar_Data = atom({
  key: TRIGGER_UPDATE_PL_SIDEBAR_DATA,
  default: false,
});

export const Pl_Sidebar_Update_Opp_Payload = atom({
  key: PL_SIDEBAR_UPDATE_OPP_PAYLOAD,
  default: null,
});

export const SidebarExpandCollapseState = atom({
  key: SIDEBAR_EXPAND_COLLAPSE_STATE,
  default: true,
});

export const Loading_Modal_State = atom({
  key: LOADING_MODAL_STATE,
  default: false,
});

export const Refresh_Pl_Forecast_page = atom({
  key: REFRESH_PL_FORECAST_PAGE,
  default: false,
});

export const Is_Baddata_Available = atom({
  key: IS_BADDATA_AVAILABLE,
  default: false,
});

export const Current_Page_Name = atom({
  key: CURRENT_PAGE_NAME,
  default: null,
});

export const Full_Page_Loading_State = atom({
  key: FULL_PAGE_LOADING_STATE,
  default: false,
});

export const Is_Read_Only_State = atom({
  key: IS_READ_ONLY_STATE,
  default: null,
});

export const Show_Refresh_button_State = atom({
  key: SHOW_REFRESH_BUTTON_STATE,
  default: false,
});

export const Country_Name_State = atom({
  key: COUNTRY_NAME_STATE,
  default: null,
});

export const Is_User_Available_State = atom({
  key: IS_USER_AVAILABLE_STATE,
  default: null,
});

// Single tree with sorted role
export const Flattened_Account_List_State = atom({
  key: FLATTENED_ACCOUNT_LIST_STATE,
  default: null,
});

export const Refresh_Pills_Status_State = atom({
  key: REFRESH_PILLS_STATUS_STATE,
  default: false,
});

export const Refresh_Alert_Bar_State = atom({
  key: REFRESH_ALERT_BAR_STATE,
  default: false,
});

export const Is_Opps_Bad_Data_Available_State = atom({
  key: IS_OPPS_BAD_DATA_AVAILABLE_STATE,
  default: null,
});

export const Msl_Opportunity_State = atom({
  key: MSL_OPPORTUNITY_STATE,
  default: null,
});

export const Refresh_Auth_Token = atom({
  key: REFRESH_AUTH_TOKEN,
  default: false,
});

export const Msl_Quarter_State_Info = atom({
  key: MSL_QUARTER_STATE_INFO,
  default: null,
});

export const Submission_Failure = atom({
  key: SUBMISSION_FAILURE,
  default: null,
});

export const Open_Super_User_Modal_State = atom({
  key: OPEN_SUPER_USER_MODAL_STATE,
  default: null,
});

export const Message_Modal_State = atom({
  key: MESSAGE_MODAL_STATE,
  default: {
    isOpen: false,
    headerTitle: '',
    bodyContent: '',
    closeButtonText: 'Close',
  },
});

export const Is_Msl_Delegate = atom({
  key: IS_MSL_DELEGATE,
  default: null,
});
